import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Image from 'components/common/Image'
import Mixin from 'components/common/Mixin'
import Columns from 'components/common/Columns/Columns'
import Text, { H2 } from 'components/common/Text/Text'
import Icon from 'components/common/Icon/Icon'
import Media from 'components/common/Media'
import LocallyOwnedSvg from '../../../../CareersPage/assets/Locally-Owned.svg'
import Link from 'components/common/Link/Link'
import { GOOGLE_MAPS_URL } from 'components/StoreDetailsPage/constants'

const StoreOwnerInfo = ({
  owner,
  address: {
    address1,
    zipcode,
    state,
    city
  } = {},
  locallyOwnedImage
}) =>
  <Wrapper>
    <Columns width="95px auto" vertAlign="middle">
      {
        locallyOwnedImage ?
          <LocallyOwnedImage /> :
          <OwnerImageWrapper>
            {
              owner.ownerImage ?
                <Image
                  data-at-storeowner-image
                  src={ owner.ownerImage }
                  alt={ `${owner.firstName} ${owner.lastName}` }
                  width={ 80 }
                  height={ 80 } /> :
                <Icon data-at-storeowner-icon asset="big-o-logo" width={ 80 } height={ 80 } />
            }
          </OwnerImageWrapper>
      }
      <div>
        <Section>
          <Header data-at-storeowner-address block>
            { address1 } <br />
            { city }, { state } { zipcode }
          </Header>
        </Section>
        { (owner.firstName || owner.lastName) &&
          <Section>
            <Text>{ owner.firstName } { owner.lastName }{owner.title && ','} { owner.title }</Text>
          </Section>
        }
      </div>
    </Columns>
    <GoogleMapsLink to={ `${GOOGLE_MAPS_URL}${address1},${city},${state},${zipcode}/` } target="_blank" >
      Get Directions
    </GoogleMapsLink>
  </Wrapper>

export default StoreOwnerInfo

StoreOwnerInfo.propTypes = {
  address: PropTypes.shape({
    address1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipcode: PropTypes.string
  }),
  locallyOwnedImage: PropTypes.bool,
  owner: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    ownerImage: PropTypes.string,
    title: PropTypes.string
  })
}

const Wrapper = styled.div`
  ${Mixin.clearFix()}
  ${Media.mobile`
    padding-bottom: 10px;
  `}
`

const OwnerImageWrapper = styled.div`
  position: relative;
  float: left;
  width: 95px;
  height: 80px;
  padding-right: 15px;
`

const Section = styled.div`
  & + & {
    margin-top: 8px;
  }
`

const Header = styled(H2)`
  ${Mixin.font.GothamBold(18)}
`
const LocallyOwnedImage = styled.div`
  background: url(${LocallyOwnedSvg}) center / contain no-repeat;
  width: 84px;
  height: 54px;
  margin-right: 15px;
`

const GoogleMapsLink = styled(Link)`
  margin-left: 95px;
  text-decoration: underline;
  font-weight: 700;
`
